export default __webpack_public_path__ + "static/media/logo-contact-mobile.a7cd8e1a.svg";